import { SearchIcon } from 'lucide-react'
import React, { useEffect } from 'react'
import { companySearchOptions } from '../../../utils/static/static'
// import { searchOptionsOrder } from '../../utils/static/static'
import classes from './ActiveSellers.module.css'
import PopUp from './PopUpDropdown/PopUpOne '

const SearchBar = ({ search, setSearch }) => {
    const onChange = (value) => {
        setSearch((prev) => ({ ...prev, searchBy: value }))
    }

    useEffect(() => {
        if (search.value.length <= 0) {
            setSearch((prev) => ({
                ...prev,
                isSearchAble: false,
            }))
        }
    }, [search.value])
    return (
        <div className={classes.searchContainer}>
            <div className={classes.searchInputWrapper}>
                <div className={classes.searchIconWrapper}>
                    <SearchIcon className={classes.searchIcon} size={20} />
                </div>
                <input
                    type="text"
                    placeholder="Search Your Company....."
                    value={search.value}
                    onChange={(e) => setSearch((prev) => ({ ...prev, value: e.target.value, isSearchAble: true }))}
                    className={classes.searchInput}
                />
                <div className={classes.popup}>
                    <PopUp
                        options={companySearchOptions}
                        parentClass=""
                        defaultValue={companySearchOptions[0]}
                        placeholder=""
                        filters={''}
                        onChange={onChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default SearchBar
